import { render, staticRenderFns } from "./bodyKunde.vue?vue&type=template&id=ca731b0e&"
import script from "./bodyKunde.vue?vue&type=script&lang=js&"
export * from "./bodyKunde.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports